import { ArrowUp, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PillButton } from "./PillButton";

const suggestedPrompts = [
  "Why did engagement drop in Q3?",
  "Surface attrition risks",
  "Summarize last week's pulse",
];

export const HeroChat = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden">
      <div className="container mx-auto px-3 lg:px-8 pt-6">
        <div className="relative mkt-gradient-hero mkt-grain rounded-[2rem] overflow-hidden px-6 sm:px-10 lg:px-16 py-20 sm:py-28 lg:py-36">
          {/* Soft light streaks */}
          <div className="absolute -right-32 top-10 w-[500px] h-[500px] rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <div className="absolute -left-40 bottom-0 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl mx-auto text-center text-white">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-xs font-medium mb-6">
              <Sparkles className="h-3.5 w-3.5" />
              100% anonymous · Built for HR
            </div>
            <h1 className="text-[44px] sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
              The Anonymous Feedback Tool{" "}
              <span className="inline-block bg-white/95 text-[hsl(var(--mkt-primary-deep))] rounded-full px-5 py-1 align-middle">
                HR Trusts
              </span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-white/85 font-medium">
              Get the truth about culture, retention, and morale — by chatting to AI. Setup in 5 minutes.
            </p>

            {/* Mock chat input */}
            <div className="mt-10 max-w-2xl mx-auto bg-white rounded-3xl mkt-shadow-card p-3 text-left">
              <div className="px-4 pt-3 pb-2 text-sm text-muted-foreground">
                Ask Co-pilot what's driving turnover this quarter…
              </div>
              <div className="flex justify-end p-1.5">
                <button
                  onClick={() => navigate("/auth?mode=signup")}
                  className="h-10 w-10 rounded-2xl bg-[hsl(var(--mkt-primary))] hover:bg-[hsl(var(--mkt-primary-deep))] text-white inline-flex items-center justify-center transition shadow-lg shadow-[hsl(var(--mkt-primary)/0.4)]"
                  aria-label="Send"
                >
                  <ArrowUp className="h-4 w-4" />
                </button>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
              {suggestedPrompts.map((p) => (
                <button
                  key={p}
                  onClick={() => navigate("/auth?mode=signup")}
                  className="px-4 py-2 rounded-full bg-white/95 text-foreground text-sm font-medium hover:bg-white transition"
                >
                  {p}
                </button>
              ))}
            </div>

            <div className="mt-12 flex items-center justify-center gap-3">
              <PillButton variant="primary" size="lg" onClick={() => navigate("/auth?mode=signup")}>
                Start Free Trial
              </PillButton>
              <PillButton variant="white" size="lg" onClick={() => navigate("/contact")}>
                Book Demo
              </PillButton>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/75">
              <span>15-day free trial</span><span aria-hidden>·</span>
              <span>No credit card</span><span aria-hidden>·</span>
              <span>GDPR compliant</span><span aria-hidden>·</span>
              <span>Setup in 5 min</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
